export default __webpack_public_path__ + "img/Image-500@2x.a47dd8ddba5a4ba28cf445176262c507.png";